import PropTypes from 'prop-types';
import { ReviewItemPropTypeJSON } from '../../shared/propTypes';

export const ReviewItemPropType = PropTypes.shape(ReviewItemPropTypeJSON).isRequired;
